import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, loadMoreList, tool, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, loadMoreList, tool, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        age_group: ''
      },
      rules: {
        age_group: [{
          required: true,
          message: "请输入年龄组名称",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.formData.id = data.id;
                  _this.formData.age_group = data.age_group;
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);

      if (isClear) {
        // 完全重置 formData 对象
        this.formData = {
          id: "",
          age_group: ''
        }; // 重置表单验证状态

        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this2.formData.id ? 'ageGroupUpd' : 'ageGroupAdd';

                    _this2.$api[reqFn](_this2.formData).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success("操作成功!");

                        _this2.dialogFormVisible = false;

                        _this2.$emit('change');
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};